import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import axios from "../../../axios";

const ContestCard = ({
  contest,
  contestPage,
  serialNumber,
  onChangeStatus,
  onSendNotification,
  onCancelContest,
}) => {
  const [joinedSlots, setJoinedSlots] = useState(0);
  const [totalSlots, setTotalSlots] = useState(contest.totalSlot || 0);
  const [totalQuestions, setTotalQuestions] = useState(0);

  useEffect(() => {
    if (!contest?._id) return;

    axios
      .get(`getTotalUserJoinedContestCount/${contest._id}`)
      .then((res) => {
        setJoinedSlots(res?.data?.result?.totalUserJoinedCount || 0);
        setTotalSlots(res?.data?.result?.totalSlot || contest.totalSlot || 0);
      })
      .catch(() => {
        setJoinedSlots(0);
        setTotalSlots(contest.totalSlot || 0);
      });
  }, [contest?._id, contest.totalSlot]);

   useEffect(() => {
              if (!contest?._id) return;
              axios
                .get(`getContestQuestionsByContestId/${contest?._id}`)
                .then((res) => {
                  const count = res?.data?.result?.totalQuestions;
                  console.log(count,"total questions")
                  if (typeof count === "number") {
                    setTotalQuestions(count);
                  }
                })
                .catch((err) => {
                  setTotalQuestions(0);
                });
            }, [contest?._id]);

  return (
    <article className="min-w-0 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-semibold text-gray-400">
            #{serialNumber}
          </p>

          <h3 className="break-words text-base font-bold text-purple">
            {contest.contestName || "Unnamed Contest"}
          </h3>
        </div>

        <span
          className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-semibold ${
            contest.isActive
              ? "bg-green-100 text-green-700"
              : "bg-gray-100 text-gray-600"
          }`}
        >
          {contest.isActive ? "Active" : "Inactive"}
        </span>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
        <Info title="Entry Coin" value={contest.entryCoin || 0} />
        <Info title="Prize Pool" value={contest.prizePoolCoin || 0} />
        <Info title="First Prize" value={contest.winnerPrizes?.[0] || 0} />
        <Info title="Joined Slot" value={`${joinedSlots}/${totalSlots || "-"}`} />
        <Info
          title="Start On"
          value={dayjs(contest.startTime).format("D MMM, YYYY h:mm A")}
        />
        <Info
          title="Total Questions"
          value={totalQuestions}
        />
      </div>

      <div className="mt-5 grid grid-cols-2 gap-2">

        <Link
          to={`/dash/edit-contest/${contest._id}`}
          className="rounded-lg bg-purple py-2 text-center text-sm font-semibold text-white"
        >
          Edit
        </Link>

        <Link
          to={`/dash/viewcontest-question/${contest._id}`}
          className="rounded-lg border border-purple py-2 text-center text-sm font-semibold text-purple"
        >
          Questions
        </Link>

        <Button
          size="sm"
          onClick={() => onChangeStatus(contest)}
        >
          Change Status
        </Button>

        <Button
          size="sm"
          onClick={() => onSendNotification(contest)}
        >
          🔔 Notification
        </Button>

        <Link
          to={`/dash/viewcontest-result/${contest._id}`}
          state={{ returnToContestPage: contestPage }}
          className="rounded-lg bg-purple py-2 text-center text-sm font-semibold text-white"
        >
          View Result
        </Link>

        <Link
          to={`/dash/join-user/${contest._id}`}
          className="rounded-lg bg-purple py-2 text-center text-sm font-semibold text-white"
        >
          Join Users
        </Link>

        <Link
          to={`/dash/addcontest-question/${contest._id}`}
          className="rounded-lg bg-blue-600 py-2 text-center text-sm font-semibold text-white"
        >
          Add Questions
        </Link>

        {!contest.isCancelled && (
          <Button
            size="sm"
            colorScheme="red"
            onClick={() => onCancelContest(contest._id)}
          >
            ❌ Cancel Contest
          </Button>
        )}

      </div>
    </article>
  );
};

const Info = ({ title, value }) => (
  <div>
    <p className="text-xs text-gray-500">{title}</p>
    <p className="font-semibold">{value}</p>
  </div>
);

export default ContestCard;
